export default __webpack_public_path__ + "static/media/img.c04e130e.svg";